import type { StripeIntegrationConfiguration } from '@vy/types';
import { INTEGRATION_PROVIDERS } from '@vy/types';
import type { DeepPartial } from 'react-hook-form';
import type { StripeConfigurationFormValues } from '../StripeConfigurationFormSchema';
import { SYNC_DIRECTIONS } from '../StripeConfigurationFormSchema';

export function getStripeIntegrationSettings(configuration: StripeConfigurationFormValues) {
  return {
    integrationProvider: INTEGRATION_PROVIDERS.stripe,
    integrationConfiguration: mapFormValuesToStripeSettings(configuration),
  };
}

function mapFormValuesToStripeSettings(
  formValues: StripeConfigurationFormValues,
): DeepPartial<StripeIntegrationConfiguration> {
  return {
    autoExportCreatedCustomers: formValues.syncCustomer === SYNC_DIRECTIONS.SYNC_FROM_VAYU,
    autoImportCustomers: formValues.syncCustomer === SYNC_DIRECTIONS.SYNC_TO_VAYU,
    autoExportInvoices: formValues.syncApprovedInvoices,
    syncPaymentRefIdToErp: formValues.syncPaymentRefIdToErp,
  };
}
